import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3 className="footer-logo">IdlyKadai 🍛</h3>
          <p className="footer-tagline">Authentic South Indian Cuisine</p>
        </div>
        <div className="footer-info">
          <div className="footer-section">
            <h4>Delivery Locations</h4>
            <p>Houston • Sugar Land • Katy</p>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Coming Soon!</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-text">
            &copy; {currentYear} IdlyKadai. All rights reserved.
          </p>
          <p className="footer-made-with">
            Made with ❤️ and 🌶️
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
